import { useQuery } from '@tanstack/react-query'
import { fetchBMData } from './fetchBMData'
import { TagStatus } from './BMDataTypes'

export const useTagsStatusQuery = (networkIdEnc: string) => {
  return useQuery<TagStatus[]>({
    queryKey: ['tags/status', networkIdEnc],
    queryFn: () => fetchBMData<TagStatus[]>('tags/status', networkIdEnc),
  })
}
